import _Abstract from "system/abstract"

export default class Component_MoveOnScroll extends _Abstract {

  constructor(el, options) {
    super(el, $.extend(true, {"offset_animation_start_pixels":0,"reverse_movement":false, "offset_animation_by_element_top_offset": false}, options), 'component')
    
    this.BEGIN_ON_SCREEN_PERCENTAGE = typeof this.options.begin_scroll_percentage === "undefined" ? 5 : this.options.begin_scroll_percentage;
    this.END_ON_SCREEN_PERCENTAGE =  typeof this.options.end_scroll_percentage === "undefined" ? 80 : this.options.end_scroll_percentage;;
    this.$window = $(window);
    this.$parent = this.$el.parent();
    this.initialise();
  }

  initialise()
  {
      this.setPositionBasedOnScroll();
  }


  setPositionBasedOnScroll()
  {
      var percentageOfMovement = this.getPercentageOfMovement();
      var oneScalePercentageOfMovement = (percentageOfMovement / 100);

      if(this.options.reverse_movement)
      {
          oneScalePercentageOfMovement = 1 - oneScalePercentageOfMovement;
      }

      var left = this.options.left * oneScalePercentageOfMovement;
      var top = this.options.top * oneScalePercentageOfMovement;
      this.$el.css("transform","translate3d("+left+"rem,"+top+"rem,0)");


      window.requestAnimationFrame(() => this.setPositionBasedOnScroll());
  }

  getPercentageOfMovement()
  { 
      var topOfParent = this.$parent.offset().top ;
      var windowHeight = this.$window.height();
      var scrollTopPosition = this.$window.scrollTop();

      if(this.options.offset_animation_start_pixels)
      {
          scrollTopPosition -= this.options.offset_animation_start_pixels;
      }

      if(this.options.offset_animation_by_element_top_offset)
      {
          scrollTopPosition -= (this.$window.height() - topOfParent);
      }

      var scrollTopPlusWindowHeight = scrollTopPosition + windowHeight;




      var pixelsOfElementOnScreen = scrollTopPlusWindowHeight - topOfParent;
      var percentageOnScreen = pixelsOfElementOnScreen / windowHeight;
      if(percentageOnScreen < 0)
      {
          percentageOnScreen = 0;
      }
      else if(percentageOnScreen > 1)
      {
          percentageOnScreen = 1;
      }

      return percentageOnScreen * 100;
  }



}



/** WEBPACK FOOTER **
 ** ./components/move-on-scroll.js
 **/